import endpoints from '@/utils/constants';
import { apiHelper } from '@/utils/helpers';
import serviceRequestQuotationUtil from '@/utils/ServiceRequestQuotationUtil';

const actions = {
    saveServiceRequestQuotation(context, payload) {
        const serviceRequest = context.rootState.serviceRequest.serviceRequest;
        const statusList = context.rootState.status.statusList;
        const serviceRequestQuotation = serviceRequestQuotationUtil.restructureQuotation(context.state.serviceRequestQuotation, {
            vendorId: serviceRequest.vendorId ? serviceRequest.vendorId : null,
            payload,
            detailProductData: context.state.detailedProductData,
            detailedLaborCosts : context.state.detailedLaborCosts,
            statusList : statusList
        });
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload.serviceRequestId}/quotations`, serviceRequestQuotation).then((res) => {
                if (res.status === 201) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    getServiceRequestQuotations(context, payload) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/quotations/`)
            .then(res => {
                    if (res.status === 200) {
                        context.commit('setServiceRequestQuotationList', res.data)
                        resolve(res.data)
                    }
                }).catch(err => {
                    reject(err)
                })
        })
    },

    getQuotations(context, query) {
        const url = new URL(`${endpoints.BASE_URL}/api/v1/service-request-quotations/`);
        if (query) {
            url.search = new URLSearchParams(query);
        }
        return new Promise((resolve, reject) => {
            apiHelper.call('get', url)
            .then(res => {
                    if (res.status === 200) {
                        context.commit('setQuotationList', res.data)
                        resolve(res.data)
                    }
                }).catch(err => {
                    reject(err)
                })
        })
    },

    getServiceRequestQuotationDetails(context, payload) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get',`${endpoints.BASE_URL}/api/v1/service-request-quotations/${payload}`)
            .then(res => {
                if(res.status === 201) {
                    context.commit('setQuotation', res.data)
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            });

        }) 
    },

    updateServiceRequestQuotation(_, payload) {
        return new Promise((resolve,reject) => {
            apiHelper.call('patch', `${endpoints.BASE_URL}/api/v1/service-request-quotations/${payload.serviceRequestQuotationId}`, payload)
            .then(res => {
                if(res.status === 200) {
                    resolve(res);
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    saveQuotationFromPos(_, payload) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload.serviceRequestId}/quotations`, payload).then((res) => {
                if (res.status === 201) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    // print quotation
    printQuotation(_, payload) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post',`${endpoints.PRINTER_API_URL}${endpoints.PRINT_API.quotation}`, payload)
                .then(res => {
                    if (res.status === 200) {
                        resolve(res);                        
                    }
                }).catch(err => {
                    reject(err);
            })
        });
    }
}

export default actions;